<template>
  <div class="locale-changer">
    <select
      class="custom-select custom-select-sm"
      v-model="$i18n.locale"
      v-on:change="setLocale($i18n.locale)"
    >
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{
        lang
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'i18n',
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  },
  data() {
    return { langs: ['en', 'ro', 'de'] }
  }
}
</script>

<style>
.custom-select {
  position: relative;
  z-index: 2;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  outline: none;
  border: 1px solid #2e2f2f;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  width: 100%;
  color: #80868b;
}
.locale-changer {
  max-width: 15em;
  min-width: 7em;
}
</style>
